import React, { Component, useCallback } from 'react';
import intl from "react-intl-universal";
import { Link } from "react-router-dom";
import { FormGroup, FormControl, ProgressBar } from "react-bootstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Dialog, DialogContent } from "@material-ui/core";
import { useDropzone } from 'react-dropzone';
import parseJpeg from './parseJpeg';
import parseTiff from './parseTiff';
import exifr from 'exifr/dist/full.umd';
import trashImg from '../../img/Icon feather-trash-2.png';
import plusIcon from "../../img/Plus_Icon.png";
import * as SLCommon from "../../slCommon";

function DragAndDrop(props) {

    const onDrop = useCallback((acceptedFiles) => {
        props.handleIsLoading(true);
        props.handleErrorMessage("");
        //props.ResetState();
        getExifTagsData(acceptedFiles, props).then(numOfRejected => {
            if (numOfRejected.count > 0 && numOfRejected.reason === intl.get("PM_Cloud_PhaseI_No_GP_Available")) {
                props.handleErrorMessage(intl.get("PM_Cloud_PhaseI_No_GP_Available"));
            }
            else if (numOfRejected.count > 0 && numOfRejected.reason === intl.get("PM_New_Project_Duplicate_Files")) {
                props.handleErrorMessage(intl.get("PM_New_Project_Duplicate_Files"));
            }
            else if (numOfRejected.count > 0 && numOfRejected.count == acceptedFiles.length) {
                props.handleErrorMessage(numOfRejected.reason);
            }
            else if (numOfRejected.count > 0 && numOfRejected.count < acceptedFiles.length) {
                props.handleErrorMessage(intl.get("PM_New_Project_Some_Files_Ignored", {numOfRejectedFiles :numOfRejected.count}));
            }
            props.handleIsLoading(false);
        });
    }, [])

    const {
        acceptedFiles,
        fileRejections,
        isDragAccept,
        getRootProps,
        open,
        getInputProps
    } = useDropzone({
        onDrop,
        // accept: 'image/jpeg,image/jpg,image/tif,image/tiff',
        maxFIles: 10000,
        // Disable click and keydown behavior
        noClick: true,
        noKeyboard: true
    });

    const acceptedFileItems = acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const fileRejectionItems = fileRejections.map(({ file, errors }) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
            <ul>
                {errors.map(e => (
                    <li key={e.code}>{e.message}</li>
                ))}
            </ul>
        </li>
    ));

    async function getExifTagsData(files, props) {
        var numRejected = {
            count: 0,
            reason: ""
        };
        var acceptedPhotos = [];
        var acceptedPhotosDict = {};
        var imagesSize = 0;
        var RequiredGP = 0;
        await Promise.all(files.map(async (file) => {
            try {
                if (file.size === 0) {
                    numRejected.count++;
                    numRejected.reason = intl.get("PM_New_Project_Invalid_Type");
                    return;
                }
                if (props.CheckDuplicateFileNames(file.path)) {
                    numRejected.count++;
                    numRejected.reason = intl.get("PM_New_Project_Duplicate_Files");
                    return;
                }
                if (file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/tif" && file.type !== "image/tiff") {
                    numRejected.count++;
                    numRejected.reason = intl.get("PM_New_Project_Invalid_Type");
                    return;
                }
                if (props.isSubLoginType) {
                    const base = file.name.substring(0, file.name.lastIndexOf('.'));
                    // Check if the base name ends with _G or _RE
                    if(base.toLowerCase().endsWith('_g') || base.toLowerCase().endsWith('_re')) {
                        numRejected.count++;
                        numRejected.reason = intl.get("PM_New_Project_Invalid_Type");
                        return;
                    }
                }
                const data = await exifr.parse(file, ['ExifImageHeight', 'ExifImageWidth', 'GPSLongitude', 'GPSLatitude', 'GPSAltitude']);
                if (data !== undefined && data.GPSLongitude !== undefined && data.GPSLatitude !== undefined && data.GPSAltitude !== undefined) {

                    if ((data.ExifImageHeight === undefined && data.ExifImageWidth === undefined) && (data.ImageHeight === undefined && data.ImageWidth === undefined)) {
                        var sliceSize = 10 * 1024;      // 10KB
                        var fileSliceLength = sliceSize;
                        if (file.type === "image/tif" || file.type === "image/tiff") {
                            var firstIFDResult = parseTiff.getFirstIFD(await file.slice(0, 8 * 1024).arrayBuffer());        // A TIFF file begins with an 8-byte header 
                            if (firstIFDResult !== undefined) {
                                var parseTiffResult = undefined;
                                if (file.size - firstIFDResult > 1023)
                                    parseTiffResult = parseTiff.parse(await file.slice(firstIFDResult, 1 * 1024).arrayBuffer());
                                else parseTiffResult = parseTiff.parse(await file.slice(firstIFDResult).arrayBuffer());
                                if (parseTiffResult !== undefined && parseTiffResult.width !== undefined && parseTiffResult.height !== undefined) {
                                    RequiredGP += (parseTiffResult.height * parseTiffResult.width) / 1000000000;
                                }
                                else {
                                    numRejected.count++;
                                    numRejected.reason = intl.get("PM_New_Project_Invalid_Type");
                                    return;
                                }
                            }
                        }
                        else {      // Jpeg
                            var imageHasWidthAndHeight = false;
                            for (var i = 0; fileSliceLength < 5 * 1024 * 1024; i++, fileSliceLength += sliceSize) {     // Run until 5MB
                                var sliceBytes = await file.slice(0, fileSliceLength).arrayBuffer();      // 10KB
                                var uIntArray = new Uint8Array(sliceBytes);
                                var parseJpegResult = parseJpeg.parse(uIntArray);
                                if (parseJpegResult !== undefined) {
                                    RequiredGP += (parseJpegResult.height * parseJpegResult.width) / 1000000000;
                                    imageHasWidthAndHeight = true;
                                    break;
                                }
                            }
                            if (imageHasWidthAndHeight === false) {
                                numRejected.count++;
                                numRejected.reason = intl.get("PM_New_Project_Invalid_Type");
                                return;
                            }
                        }
                    }
                    // Check Height and Width of the file
                    else if (data !== undefined && (data.ExifImageHeight && data.ExifImageWidth)) {
                        RequiredGP += (data.ExifImageHeight * data.ExifImageWidth) / 1000000000;
                    }
                    else if (data !== undefined && (data.ImageHeight && data.ImageWidth)) {
                        RequiredGP += (data.ImageHeight * data.ImageWidth) / 1000000000;
                    }
                    else {      // Fail all the files
                        numRejected.count++;
                        numRejected.reason = intl.get("PM_New_Project_Invalid_Type");
                        return;
                    }
                    acceptedPhotos.push(file);
                    acceptedPhotosDict[file.path.toLowerCase()] = file.path.toLowerCase();
                    imagesSize += file.size;
                }
                else { // The image has no georeference
                    numRejected.count++;
                    numRejected.reason = intl.get("PM_New_Project_Error_No_GeoReference");
                }
            }
        catch (e) {
            numRejected.count++;
            numRejected.reason = intl.get("PM_New_Project_Invalid_Type");
            return;
        }
        }));
        
        props.AddAcceptedPhotos(acceptedPhotos, acceptedPhotosDict, imagesSize, RequiredGP);
        //console.log(numRejected);
        return numRejected;
    }


    return (
        <section className="">
            <div {...getRootProps({ className: isDragAccept ? 'dropDownClass focusedDropDownClass' : 'dropDownClass ' })}>
                <input {...getInputProps()} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div>
                        <img src={plusIcon} onClick={open} style={{ cursor: 'pointer' }} />
                    </div>
                    <div style={{ marginLeft: '30px' }}>
                        {props.acceptedPhotos.length > 0 ? <h1>{intl.get("PM_Drop_Down_Add_More_Photos_Title")}</h1> :
                            <h1>{intl.get("PM_Drop_Down_Title")}</h1>}
                        <span>{intl.getHTML("PM_Drop_Down_Description", { GPAmount: props.GPAmount.toFixed(2) })}</span>
                    </div>
                </div>

            </div>
            <aside>
                {/* <h4>Accepted files</h4>
            <ul>{acceptedFileItems}</ul>
            <h4>Rejected files</h4>
            <ul>{fileRejectionItems}</ul> */}
            </aside>
        </section>
    );
}


class newPMProjectPhaseI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessgae: "",
        };
    }

    componentDidMount() {
        if(this.props.isSubLoginType){
            //create custom identifier
            this.props.handleProjectName(SLCommon.generateUniqueString(this.props.company));
        }
        else if (this.props.projectName === "") {
            this.props.handleProjectName(SLCommon.generateUniqueString("CloudProcessing"));
        }
    }

    handleErrorMessage = (message) => {
        this.setState({ errorMessgae: message });
    };

    ResetState = () => {
        this.props.RemoveAcceptedPhotos();
        this.handleErrorMessage("");
    }

    render() {
        return (
            <React.Fragment>
                {this.state.errorMessgae ? (
                    <div className='divWarningPMCloud'>
                        {this.state.errorMessgae}
                    </div>
                ) : null}
                {this.props.endpoint_id != "" ? 
                null 
                : 
                <div style={{marginTop: '80px', display: 'flow-root'}}>
                    <h4 className="moreSpacefromTitleToTable" style={{float: 'left'}}>{intl.get("PM_New_Project_Title")}</h4>
                    <a href='https://support.skylinesoft.com/hc/en-us/articles/4699178801308' target='_blank' style={{textDecoration: 'underline', float: 'right'}}>Learn More</a>
                </div>
                }
                <div style={this.props.endpoint_id !== "" ? { marginTop: '80px', display: 'flow-root' } : {}}>
                    {!this.props.isSubLoginType ? 
                        <div>
                            <p>Identifier:</p>
                            <FormGroup controlId="firstName" className="form-label-group d-flex">
                                <FormControl
                                    className="form-control addUserFormControl"
                                    // pattern={"^[\\w\\-]{1,32}$"}
                                    maxLength="32"
                                    value={this.props.projectName}
                                    onChange={(event) => {
                                        if (
                                            event.target.validity.valid ||
                                            event.target.value === ""
                                        )
                                            this.props.handleProjectName(event.target.value);
                                    }}
                                    placeholder={intl.get("Identifier_Name_Placeholder")}
                                    required
                                />
                            </FormGroup>
                        </div>
                    : null}
                    <div className='newPMProjectPhaseIDranNDropDiv'>
                        <DragAndDrop ResetState={this.ResetState} CheckDuplicateFileNames={this.props.CheckDuplicateFileNames} AddAcceptedPhotos={this.props.AddAcceptedPhotos} handleErrorMessage={this.handleErrorMessage} GPAmount={this.props.GPAmount} handleIsLoading={this.props.handleIsLoading} acceptedPhotos={this.props.acceptedPhotos} isSubLoginType={this.props.isSubLoginType}/>
                        <div style={{ fontSize: '13px', marginTop: '20px' }}>
                            <div style={{ width: '230px', float: 'right' }}>
                                <div>{intl.get("PM_Cloud_PhaseI_Package_Usage", { numOfGigapixel: this.props.GPAmount.toFixed(2) })}</div>
                                <ProgressBar className={`progressBarPhaseI${((this.props.RequiredGP / this.props.GPAmount) * 100) > 100 ? ' progressBarOver100' : ''}`} now={((this.props.RequiredGP / this.props.GPAmount) * 100)} />
                                <span>{((this.props.RequiredGP / this.props.GPAmount) * 100) > 100 ? '>100%' : ((this.props.RequiredGP / this.props.GPAmount) * 100).toFixed(2) + '%'}</span>
                            </div>
                        </div>
                        {this.props.imagesSize > 0 ?
                            <div style={{ marginTop: "20px" }}>
                                <div style={{ fontSize: "17px", fontWeight: "bold" }}>{intl.get("PM_New_Project_Upload_Details", { photosSize: this.props.acceptedPhotos.length })}</div>
                                <div style={{ display: 'inline-flex'}}>
                                    <div style={{ fontSize: '13px', float: 'left' }}>{intl.get("PM_Cloud_PhaseI_RequiredGP", {RequiredGP: this.props.RequiredGP.toFixed(2)})}</div>
                                    <div style={{ float: "left", marginRight: "20px" }} className="vl" />
                                    <div style={{ fontSize: '13px' }}>{this.props.formatBytes(this.props.imagesSize)}</div>
                                </div>
                                <div>
                                <button className="RemoveAllButtonClass"
                                    onClick={event => {
                                        this.ResetState();
                                    }}>
                                    <img src={trashImg} style={{marginBottom: '5px', marginLeft: '-6px'}}></img> Remove All
                                </button>
                                </div>
                            </div>
                        : null
                    }
                    </div>
                </div>
                <div className={`NextPrevButtonsClass ${this.props.isSubLoginType ? "NextPrevButtonsWithoutFooter" : ""}`}>
                    <div className="NextButtonDivClass" style={{ float: "right", marginRight: '40px', marginLeft: "30px" }}>
                        <button 
                            className="btn-primary btn btn-default NextButtonClass" 
                            disabled={this.props.projectName == ""}
                            onClick={(event) => {
                            var resMessage = this.props.checkMovingFromPhaseItoPhaseII();
                            if (resMessage === "")
                                this.props.setPageNumer(2);
                            else this.handleErrorMessage(resMessage);
                            }}
                        >NEXT</button>
                    </div>
                </div>

                
                <Dialog
                open={this.props.isLoading}
                aria-labelledby="form-dialog-title align-center"
              >
                <DialogContent>
                <CircularProgress size={60}/>
                </DialogContent>
              </Dialog>
            </React.Fragment>
        );
    }
}

export default newPMProjectPhaseI;